import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import RetailSlogan2 from 'containers/retail/sections/compare-energy-rates/RetailSlogan2';
import CompareRatesForm2, {
  CompareRatesFormProps,
} from 'containers/retail/sections/compare-energy-rates/CompareRatesForm2';

const Wrapper = withStyles((theme) => ({
  root: {
    marginTop: 90,
    [theme.breakpoints.up('sm')]: {
      marginTop: 162,
    },
  },
}))(Box);

const Container = withStyles((theme) => ({
  root: {
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}))(Grid);

const RetailTopSection2: FC<CompareRatesFormProps> = (props) => {
  return (
    <Wrapper>
      <Container container spacing={4}>
        <Grid item xs={12} md={6}>
          <RetailSlogan2 />
        </Grid>
        <Grid item xs={12} md={6}>
          <CompareRatesForm2 {...props} />
        </Grid>
      </Container>
    </Wrapper>
  );
};

export default RetailTopSection2;
